/*eslint no-unused-vars: ["off"]*/
/*eslint eqeqeq: ["off"]*/

/*eslint  array-callback-return: ["off"]*/
import { all, takeEvery, put, call } from 'redux-saga/effects';
import axios from 'axios';
// import { getToken } from '@iso/lib/helpers/utility';
import siteConfig from '@iso/config/site.config';
import notification from '@iso/components/Notification';
import actions from './actions';
const onCallReqeust = async (URI) =>
  await axios
    .get(URI)
    .then((res) => res)
    .catch((error) => error);
const onPostCallReqeust = async (sendData, URI) =>
  await axios
    .post(URI, sendData)
    .then((res) => res)
    .catch((error) => error);
const onPutCallReqeust = async (sendData, URI) =>
  await axios
    .put(URI, sendData)
    .then((res) => res)
    .catch((error) => error);
const onDeleteCallReqeust = async (URI) =>
  await axios
    .delete(URI)
    .then((res) => res)
    .catch((error) => error);
export function* getAsset() {
  axios.defaults.headers.get['Authorization'] = localStorage.getItem(
    'id_token'
  );
  try {
    const callResult = yield call(onCallReqeust, `${siteConfig.apiUrl}/assets`);

    if (callResult.response != undefined) {
      notification('error', callResult.response.data.msg);
    } else {
      var temp = [];

      temp = callResult.data.data;
      callResult.data.data.map((value, index) => {
        value.key = value._id;
        value.title = value.strName;
        value.parentid = value.intAssetParentID;
      });

      yield put({
        type: actions.GET_ASSET_REDUCER,
        assets: callResult.data.data, //createDemoData(),
        assets1: temp,
      });
    }
  } catch (error) {
    notification('error', 'Internal server error!');
  }
}
export function* getAllAsset({ payload }) {
  axios.defaults.headers.get['Authorization'] = localStorage.getItem(
    'id_token'
  );
  try {
    // console.log(payload.vesselId)
    const callResult = yield call(onCallReqeust, `${siteConfig.apiUrl}/assets/allAsset`);  
    if (callResult.response != undefined) {
      notification('error', callResult.response.data.msg);
    } else {
      var temp = [];

      callResult.data.data.map((value, index) => {
        value.key = value._id;
        value.title = value.strName;
        value.parentid = value.intAssetParentID;
        temp.push(value);
      });
 
      yield put({
        type: actions.GET_ASSET_REDUCER,
        // assets: callResult.data.data, //createDemoData(),
        assets: temp,
      });
    }
  } catch (error) {
    notification('error', 'Internal server error!');
  }
}

export function* getSupplies({ payload }) {
  axios.defaults.headers.get['Authorization'] = localStorage.getItem(
    'id_token'
  );
  try {
    const callResult = yield call(onCallReqeust, `${siteConfig.apiUrl}/supplies`);

    if (callResult.response != undefined) {
      notification('error', callResult.response.data.msg);
    } else {
      var temp = [];

      // temp = callResult.data.data;
      callResult.data.data.map((value, index) => {
        value.key = value._id;
        value.title = value.strName;
        value.parentid = value.intAssetParentID;
      });
      
      if(payload.vesselId != 'all') {
        callResult.data.data.map(value =>{
          if(value.intVesselID == payload.vesselId) temp.push(value)
        })
      } else {
        callResult.data.data.map(value =>{
          temp.push(value);
        })
      }

      yield put({
        type: actions.GET_SUPPLIY_REDUCER,
        data: temp, //createDemoData(),
        // assets1: temp,
      });
    }
  } catch (error) {
    notification('error', 'Internal server error!');
  }
}

export function* getPrintDataAsset({ payload }) {
  axios.defaults.headers.get['Authorization'] = localStorage.getItem(
    'id_token'
  );
  try {
    const callResult = yield call(
      onCallReqeust,
      `${siteConfig.apiUrl}/assets/print/${payload.assetId}`
    );

    if (callResult.response != undefined) {
      notification('error', callResult.response.data.msg);
    } else {
      yield put({
        type: actions.GET_PRINT_DATA_BY_ID,
        asset: callResult.data.data,
        msg: null,
      });
    }
  } catch (error) {
    notification('error', 'Internal server error!');
  }
}
export function* getAsetById({ payload }) {
  axios.defaults.headers.get['Authorization'] = localStorage.getItem(
    'id_token'
  );
  try {
    const callResult = yield call(
      onCallReqeust,
      `${siteConfig.apiUrl}/assets/ID/${payload.assetId}`
    );

    if (callResult.response != undefined) {
      notification('error', callResult.response.data.msg);
    } else {
      yield put({
        type: actions.GET_ASSET_BYID_REDUCER,
        asset: callResult.data.data,
        msg: null,
      });
    }
  } catch (error) {
    notification('error', 'Internal server error!');
  }
}

export function* getAssetByFilter({ payload }) {
  axios.defaults.headers.get['Authorization'] = localStorage.getItem(
    'id_token'
  );
  try {
    const callResult = yield call(
      onCallReqeust,
      `${siteConfig.apiUrl}/assets/filter/${payload.filterIds}`
    );

    if (callResult.response != undefined) {
      notification('error', callResult.response.data.msg);
    } else {
      var temp = [];

      temp = callResult.data.data;
      callResult.data.data.map((value, index) => {
        value.key = value._id;
        value.title = value.strName;
        value.parentid = value.intAssetParentID;
      });

      yield put({
        type: actions.GET_ASSET_REDUCER,
        assets: temp, //createDemoData(),
        assets1: temp,
      });
    }
  } catch (error) {
    notification('error', 'Internal server error!');
  }
}

export function* addAsset({ payload }) {
  axios.defaults.headers.post['Authorization'] = localStorage.getItem(
    'id_token'
  );
  try {
    const callResult = yield call(
      onPostCallReqeust,
      payload.sendData,
      `${siteConfig.apiUrl}/assets`
    );
    if (callResult.response != undefined) {
      notification('error', callResult.response.data.msg);
    } else {
       notification('success',callResult.data.msg)
      yield put({
        type: actions.ADD_SUCCESS,
        asset: callResult.data.data,
      });
    }
  } catch (error) {
    console.log(error, 'this is saga user error');
    yield put({ type: actions.ADD_FAILED, msg: 'Server Internal error!' });
  }
}


export function* addSupply({ payload }) {
  axios.defaults.headers.post['Authorization'] = localStorage.getItem(
    'id_token'
  );
  try {
    const callResult = yield call(
      onPostCallReqeust,
      payload.sendData,
      `${siteConfig.apiUrl}/supplies`
    );
    if (callResult.response != undefined) {
      notification('error', callResult.response.data.msg);
    } else {
      notification('success', callResult.data.msg)
      yield put({
        type: actions.ADD_SUCCESS,
        asset: callResult.data.data,
      });
    }
  } catch (error) {
    console.log(error, 'this is saga user error');
    yield put({ type: actions.ADD_FAILED, msg: 'Server Internal error!' });
  }
}
export function* updateData({ payload }) {
  axios.defaults.headers.put['Authorization'] = localStorage.getItem(
    'id_token'
  );
  try {
    const callResult = yield call(
      onPutCallReqeust,
      payload.sendData,
      `${siteConfig.apiUrl}/assets/${payload.id}`
    );

    if (callResult.response != undefined) {
      notification('error', callResult.response.data.msg);
    } else {
      notification('success', callResult.data.msg);
      yield put({
        type: actions.UPDATE_SUCCESS,
      });
    }
  } catch (error) {
    notification('success', 'Server Internal error!');
  }
}

export function* updateSupplyData({ payload }) {
  axios.defaults.headers.put['Authorization'] = localStorage.getItem(
    'id_token'
  );
  try {
    const callResult = yield call(
      onPutCallReqeust,
      payload.sendData,
      `${siteConfig.apiUrl}/supplies/${payload.id}`
    );

    if (callResult.response != undefined) {
      notification('error', callResult.response.data.msg);
    } else {
      notification('success', callResult.data.msg);
      yield put({
        type: actions.UPDATE_SUCCESS,
      });
    }
  } catch (error) {
    notification('success', 'Server Internal error!');
  }
}

export function* deleteData({ payload }) {
  axios.defaults.headers.delete['Authorization'] = localStorage.getItem(
    'id_token'
  );
  try {
    const callResult = yield call(
      onDeleteCallReqeust,
      `${siteConfig.apiUrl}/assets/${payload.id}`
    );
    if (callResult.response != undefined) {
      notification('error', callResult.response.data.msg);
    } else {
      notification('success', callResult.data.msg);
      yield put({
        type: actions.DELETE_SUCCESS,
        msg: callResult.data.msg,
      });
    }
    console.log(callResult, 'this is call Request');
  } catch (error) {
    notification('error', 'Server Internal error!');
  }
}

export function* createNumber({ payload }) {
  axios.defaults.headers.post['Authorization'] = localStorage.getItem(
    'id_token'
  );
  try {
    const callResult = yield call(
      onCallReqeust,
      `${siteConfig.apiUrl}/assets/numberId`
    );
    if (callResult.response != undefined) {
      notification('error', callResult.response.data.msg);
    } else {
      // notification('success',callResult.data.msg)     
      yield put({
        type: actions.CREATE_NUMBER_SUCCESS,
        assetNumber: callResult.data.data[0] ? callResult.data.data[0]._id+1:null,
      });
    }
  } catch (error) {
    console.log(error, 'this is saga user error');
    yield put({ type: actions.ADD_FAILED, msg: 'Server Internal error!' });
  }
}

export default function* rootSaga() {
  yield all([
    yield takeEvery(actions.GET_ASSET, getAsset),
    yield takeEvery(actions.GET_SUPPLY_ASSETS, getAllAsset),    
    yield takeEvery(actions.GET_SUPPLIES, getSupplies),
    yield takeEvery(actions.GET_PRINT_DATA, getPrintDataAsset),
    yield takeEvery(actions.ADD_ASSET, addAsset),
    yield takeEvery(actions.ADD_SUPPLY, addSupply),    
    yield takeEvery(actions.GET_ASSET_BY_FILTER, getAssetByFilter),
    yield takeEvery(actions.GET_ASSET_BYID, getAsetById),
    yield takeEvery(actions.UPDATE_DATA, updateData),
    yield takeEvery(actions.UPDATE_SUPPLY_DATA, updateSupplyData),        
    yield takeEvery(actions.DELETE_DATA, deleteData),
    yield takeEvery(actions.CREATE_NUMBER, createNumber),
  ]);
}
